import React, { FC } from 'react';

import { Text } from '@nord/ui';

import warningSvg from '../../assets/img/warning.svg';

const BrowserSupportNotification: FC = () => (
  <div className="bg-red flex justify-center items-center">
    <img src={warningSvg} alt="Outdated browser warning icon" />
    <Text variant="caption" className="text-white text-small ml-3 py-3">
      You’re using a web browser we no longer support – for improved security and experience, please
      update your browser.
    </Text>
  </div>
);

export default BrowserSupportNotification;
